import { ObservableMap } from '@stencil/store';
import { startIdleTimeout } from '@uipath/portal-shell-util';

import { getEnvConfigField } from '../utils/EnvironmentUtil';
import Logger from '../utils/logger/logger';
import { logout } from '../utils/sessionHelper';
import { State } from './types/state';

export function enforceIdleTimeout(store: ObservableMap<State>) {
    const envConfigTimeoutInterval = (getEnvConfigField('IDLE_TIMEOUT_INTERVAL') ?? 0) * 60 * 1000;

    startIdleTimeout((localStorageTimer: number | null) => {
        const currentTime = Date.now();

        const accountTimeoutInterval = store.get('account')?.organization?.idleSessionTimeoutPeriod;
        const interval = accountTimeoutInterval ?? envConfigTimeoutInterval;

        if (interval && localStorageTimer && currentTime >= localStorageTimer + interval) {
            Logger.info('idle timeout', `localstorage timer + interval: ${`${localStorageTimer} + ${interval} >= current timer: ${currentTime}`}`, { state: store.state });
            logout(store);
        }
    });
}
